export const WarningIcon = () => (
    <svg
        data-testid={'warningIcon'}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19ZM12.6 12V9.99999C12.6 9.66862 12.3314 9.39999 12 9.39999C11.6687 9.39999 11.4 9.66862 11.4 9.99999V12C11.4 12.3314 11.6687 12.6 12 12.6C12.3314 12.6 12.6 12.3314 12.6 12ZM11.9965 14.6C12.1655 14.6 12.3084 14.5428 12.425 14.4285C12.5417 14.3142 12.6 14.1725 12.6 14.0035C12.6 13.8345 12.5429 13.6917 12.4285 13.575C12.3142 13.4583 12.1725 13.4 12.0035 13.4C11.8345 13.4 11.6917 13.4572 11.575 13.5715C11.4584 13.6858 11.4 13.8275 11.4 13.9965C11.4 14.1655 11.4572 14.3083 11.5715 14.425C11.6858 14.5417 11.8275 14.6 11.9965 14.6Z"
            fill="#ED6C02"
        />
    </svg>
);
